export default "__VITE_ASSET__BS4Scna0__"